/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingHolidayDelivery_sku = {
    readonly holidayShippingEstimations?: {
        readonly displayMessage: string | null;
        readonly termsAndConditions: string | null;
        readonly validHolidayShippingDays: ReadonlyArray<{
            readonly shipmentQuoteId: string | null;
            readonly estimatedDeliveryDay: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedShippingHolidayDelivery_sku";
};
export type PdpSharedShippingHolidayDelivery_sku$data = PdpSharedShippingHolidayDelivery_sku;
export type PdpSharedShippingHolidayDelivery_sku$key = {
    readonly " $data"?: PdpSharedShippingHolidayDelivery_sku$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingHolidayDelivery_sku">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "timezoneOffset"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingHolidayDelivery_sku",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "timezoneOffset",
              "variableName": "timezoneOffset"
            }
          ],
          "concreteType": "HolidayShippingEstimationsType",
          "kind": "LinkedField",
          "name": "holidayShippingEstimations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "termsAndConditions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ValidHolidayShippingDays",
              "kind": "LinkedField",
              "name": "validHolidayShippingDays",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shipmentQuoteId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "estimatedDeliveryDay",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};
(node as any).hash = '28b5b0f2f872905e50b57fb5940d9ddc';
export default node;
